<template>
    <div>
        <button
            @click="showConfirmationModal"
            type="button"
            :aria-label="$t('EXIT')"
            class="flex flex-row items-center bg-cloud-dark"
        >
            <img
                src="@/assets/icons/close.svg"
                alt="Close Icon"
                width="20"
                height="20"
                class="opacity-50"
            >
        </button>

        <transition name="fade">
            <base-modal
                v-if="showModal"
                @closeModal="showModal = false"
                @confirmModal="exitCustomization"
                :title-text="$t('CONFIRM_EXIT')"
                :copy-text="$t('CONFIRM_EXIT_COPY')"
            />
        </transition>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import BaseModal from './BaseModal.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseModal,
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            showConfirmationModal() {
                this.showModal = true;
            },

            exitCustomization() {
                this.showModal = false;

                this.customizerStore.globalCancel();
            },
        },
    };
</script>
